export default __webpack_public_path__ + "static/media/Logo1.b5a43603.png";